import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { ChannelMappingRoutingModule } from './channel-mapping-routing.module';
import { ChannelMappingComponent } from './channel-mapping.component';
import { ChannelMappingEditComponent } from './channel-mapping-edit.component';
import { DiagnosticsComponent } from '../settings/diagnostics/diagnostics.component';
import { DiagnosticsFormModalComponent } from '../settings/diagnostics/diagnostics-form-modal.component';
import { FracproChannelsComponent } from '../settings/fracpro-channels/fracpro-channels.component';
import { FracproChannelsFormModalComponent } from '../settings/fracpro-channels/fracpro-channels-form-modal.component';
import { MiscSettingsComponent } from '../settings/misc-settings/misc-settings.component';
import { WellSearchSettingsComponent } from '../settings/well-search-settings/well-search-settings.component';
import { ThemesSettingsComponent } from '../settings/themes-settings/themes-settings.component';
import { UnitsSettingsComponent } from '../settings/units-settings/units-settings.component';

@NgModule({
  declarations: [
    ChannelMappingComponent,
    ChannelMappingEditComponent,
    DiagnosticsComponent,
    DiagnosticsFormModalComponent,
    FracproChannelsComponent,
    FracproChannelsFormModalComponent,
    MiscSettingsComponent,
    WellSearchSettingsComponent,
    ThemesSettingsComponent,
    UnitsSettingsComponent
  ],
  imports: [
    SharedModule,
    ChannelMappingRoutingModule,
  ],
  entryComponents: [
    ChannelMappingEditComponent,
    DiagnosticsFormModalComponent,
    FracproChannelsFormModalComponent
  ]
})
export class ChannelMappingModule { }
